import { render, staticRenderFns } from "./UndefinedPage.vue?vue&type=template&id=492e935d&"
import script from "./UndefinedPage.vue?vue&type=script&lang=js&"
export * from "./UndefinedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports